import type { ReactNode } from 'react'

/** Standard page frame: display title, optional actions, width-capped column. */
export default function Page({
  title,
  eyebrow,
  actions,
  children,
}: {
  title: string
  eyebrow?: string
  actions?: ReactNode
  children?: ReactNode
}) {
  return (
    <div style={{ padding: '30px var(--gutter) 60px' }}>
      <div className="sections" style={{ maxWidth: 'var(--content-max)', margin: '0 auto' }}>
        <header className="spread" style={{ alignItems: 'flex-end' }}>
          <div className="stack" style={{ gap: 4 }}>
            {eyebrow && <span className="t-eyebrow">{eyebrow}</span>}
            <h1 className="t-display-l">{title}</h1>
          </div>
          {actions}
        </header>
        {children}
      </div>
    </div>
  )
}
